import { render, staticRenderFns } from "./QUpload.vue?vue&type=template&id=040f7afb&scoped=true"
import script from "./QUpload.vue?vue&type=script&lang=js"
export * from "./QUpload.vue?vue&type=script&lang=js"
import style0 from "./QUpload.vue?vue&type=style&index=0&id=040f7afb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040f7afb",
  null
  
)

export default component.exports